module.exports = __webpack_public_path__ + "assets/img/teacher (35).4aac6e1c.png";